/**
 *
 * @param {array} fields array of strings
 * @param  {object} args
 */
export const createRuleIsEmpty = (fields, args) =>
  fields.map((field) => ({
    field,
    method: 'isEmpty',
    validWhen: false,
    ...(args || {}),
  }));

/**
 *
 * @param {array} fields array of strings
 * @param  {object} args
 */
export const createRuleIsLength = (fields, args) => {
  return fields.map((field) => ({
    field,
    method: 'isLength',
    validWhen: true,
    ...(args || {}),
  }));
};
